import { API_PATH, BASE_PATH } from './config';
import React from 'react';
import { useTranslation } from 'react-i18next';

const ActivityForm = ({ onActivityAdded, onCancel }) => {
    const { t } = useTranslation();
    const [title, setTitle] = React.useState('');
    const [notes, setNotes] = React.useState('');
    const [startTime, setStartTime] = React.useState('');
    const [endTime, setEndTime] = React.useState('');
    const [location, setLocation] = React.useState('');
    const [error, setError] = React.useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        const token = localStorage.getItem('token');
        if (!token) {
            setError(t('no_token_error'));
            return;
        }

        const newActivity = {
            title,
            notes,
            start_time_utc: startTime,
            end_time_utc: endTime,
            location,
        };

        try {
            const response = await fetch(`${API_PATH}/activities.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(newActivity),
            });

            const data = await response.json();

            if (response.ok) {
                alert(t('activity_added_success'));
                onActivityAdded(); // Notify parent component
            } else {
                setError(data.message || t('add_activity_failed_error'));
            }
        } catch (err) {
            setError(t('server_connection_error'));
        }
    };

    return (
        <div className="activity-form-container">
            <h2>{t('add_activity_title')}</h2>
            {error && <p style={{ color: 'red' }}>{error}</p>}
            <form onSubmit={handleSubmit}>
                <label>{t('title_label')}</label>
                <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} required />

                <label>{t('notes_label_simple')}</label>
                <textarea value={notes} onChange={(e) => setNotes(e.target.value)}></textarea>

                <label>{t('start_time_utc_label')}</label>
                <input type="datetime-local" value={startTime} onChange={(e) => setStartTime(e.target.value)} required />

                <label>{t('end_time_utc_label')}</label>
                <input type="datetime-local" value={endTime} onChange={(e) => setEndTime(e.target.value)} required />

                <label>{t('location_label')}</label>
                <input type="text" value={location} onChange={(e) => setLocation(e.target.value)} />

                <button type="submit">{t('add_activity_submit_btn')}</button>
                <button type="button" onClick={onCancel}>{t('cancel_btn')}</button>
            </form>
        </div>
    );
};

export default ActivityForm;
